<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-form ref="pembagianKoordinatorForm" id="pembagianKoordinatorForm" v-model="valid" lazy-validation>
                <v-toolbar flat>
                    <v-toolbar-title>Pembagian Koordinator</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical />
                    <v-spacer />
                </v-toolbar>
                <div class="mt-3">
                    <v-row class="mx-5">
                        <v-col lg="2" md="3" sm="4" cols="4">Delivery</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                            <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                <template v-slot:activator="{ on, attrs}">
                                    <v-text-field v-model="date" prepend-inner-icon="mdi-calendar" v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form" :rules="reqRule"></v-text-field>
                                </template>
                                <v-date-picker v-model="date"></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                            <v-select outlined dense hide-details="auto" :items="bottles" item-value="code" item-text="description" v-model="selectedVolume"></v-select>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5">
                        <v-col lg="2" md="3" sm="4" cols="4">Coordinator</v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                            <v-select v-model="selectedCoordinator" outlined dense hide-details="auto" :items="coordinators" item-value="code" item-text="name" clearable></v-select>
                        </v-col>
                        <v-col lg="2" md="3" sm="4" cols="4"></v-col>
                        <v-col lg="2" md="3" sm="8" cols="8">
                        </v-col>
                    </v-row>
                    <v-row class="mx-5 text-end">
                        <v-col>
                            <v-btn depressed color="primary" class="d-inline" @click="refreshData">Get Data</v-btn>
                            <v-btn depressed color="green" class="d-inline ms-2 white--text" @click="export2xls">Export to XLS</v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="mx-5">
                        <v-col>
                            <v-card outlined>
                                <v-simple-table class="spreadsheet-table flex-table" fixed-header height="440" ref="tableKoordinator">
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th class="header-cell" colspan="2">
                                                    
                                                </th>
                                                <th class="header-cell text-center">{{ selectedCoorName }}</th>
                                                <th>
                                                    Adjustment Logistik
                                                </th>
                                                <th class="header-cell text-center" v-if="selectedIsDiambil">
                                                    Diambil <br/>
                                                    {{ selectedPrevCoorName }}
                                                </th>
                                                <th class="header-cell text-center" v-if="selectedIsSisa">
                                                    Sisa <br/>
                                                    {{ selectedPrevCoorName }}
                                                </th>
                                                <th class="header-cell text-center">Ambil Dari <br/>
                                                    {{ selectedNextCoorName }}
                                                </th>
                                                <th class="header-cell text-center">Ambil dari <br/> Stock Adelphi</th>
                                                <th class="header-cell text-center" rowspan="2">TOTAL</th>
                                                <th class="header-cell text-center" rowspan="2">SISA</th>

                                                <th class="spreadsheet-cell text-center" :colspan="totalOutlet + 1">{{ selectedCoorName }}</th>

                                                <th class="header-cell text-center" rowspan="2">TOTAL</th>
                                            </tr>
                                            <tr>
                                                <th class="header-cell text-right" colspan="2">EXPIRED</th>
                                                <th class="header-cell text-center">{{ expiredDate }}</th>
                                                <th class="header-cell text-center">{{ expiredDate }}</th>
                                                <th class="header-cell text-center">{{ expiredDate }}</th>
                                                <th class="header-cell text-center" v-if="selectedIsDiambil">{{ expiredDate }}</th>
                                                <th class="header-cell text-center" v-if="selectedIsSisa">{{ expiredDate }}</th>
                                                
                                                <th class="header-cell text-center">{{ expiredDate }}</th>

                                                <th class="spreadsheet-cell text-center" v-for="(outlet,ido) in outlets" :key="ido">
                                                    <span>{{ outlet.outlet_name }}</span>
                                                </th>
                                                <th class="spreadsheet-cell text-center" v-for="(outlet,ido) in additionalOutlets" :key="`head_${ido}`">
                                                    <span>{{ outlet.outlet_name }}</span>
                                                    <v-btn
                                                        class="ma-2"
                                                        text
                                                        icon
                                                        color="red lighten-2" @click="removeAdditionalOutlet(outlet.outlet_code)"
                                                    >
                                                        <v-icon>mdi-close</v-icon>
                                                    </v-btn>
                                                </th>

                                                <th class="spreadsheet-cell text-center">
                                                    <v-select v-model="selectedOtherOutlet" outlined dense hide-details="auto" :items="filteredOutlets" item-value="code" return-object item-text="name" @change="handleOutlet"></v-select>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="isLoading">
                                                <tr v-for="n in 7" :key="n">
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>

                                                    <td v-for="(outlet,ido) in outlets" :key="`outlet_${ido}`"><v-skeleton-loader type="text" /></td>
                                                    
                                                    <td v-for="(outlet,ido) in additionalOutlets" :key="`additional_${ido}`"><v-skeleton-loader type="text" /></td>

                                                    <td><v-skeleton-loader type="text" /></td>
                                                    <td><v-skeleton-loader type="text" /></td>
                                                </tr>
                                            </template>
                                            <template v-else>
                                                <tr v-for="(row, idp) in items" :key="`tr_${idp}`">
                                                    <td class="header-text text-no-wrap">{{ idp + 1 }}. {{ row.product_code }}</td>
                                                    <td class="header-text text-no-wrap">{{ row.product_name }}</td>
                                                    <td class="spreadsheet-cell text-center">
                                                        <v-text-field :value="calculateQty(row)" class="disable2-input" type="number" readonly solo hide-details />
                                                        <span style="display: none;">{{ calculateQty(row) }}</span>
                                                    </td>
                                                    <td class="spreadsheet-cell text-center">
                                                        <v-text-field v-model="row.qty_logistic_adjustment"  class="spreadsheet-input" type="number" solo hide-details @wheel="$event.target.blur()" />
                                                        <span style="display: none;">{{ row.qty_logistic_adjustment }}</span>
                                                    </td>
                                                    <td class="spreadsheet-cell text-center" v-if="selectedIsDiambil">
                                                        <v-text-field :value="calculateDiambil(row)" class="disable2-input" type="number" readonly solo hide-details />
                                                        <span style="display: none;">{{ calculateDiambil(row) }}</span>
                                                    </td>
                                                    <td class="spreadsheet-cell text-center" v-if="selectedIsSisa">
                                                        <v-text-field :value="calculateSisaCoordinator(row)" class="disable2-input" type="number" readonly solo hide-details />
                                                        <span style="display: none;">{{ calculateSisaCoordinator(row) }}</span>
                                                    </td>


                                                    <td class="spreadsheet-cell text-center">
                                                        <v-text-field v-model="row.qty_from_other_coord" :readonly="selectedIsDisableAmbilDari"  :class="{'disable2-input': selectedIsDisableAmbilDari, 'spreadsheet-input': !selectedIsDisableAmbilDari }" type="number" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" />
                                                        <span style="display: none;">{{ row.qty_from_other_coord }}</span>
                                                    </td>
                                                    <td class="spreadsheet-cell text-center">
                                                        <v-text-field v-model="row.qty_from_adelphi" class="spreadsheet-input" type="number" solo hide-details @wheel="$event.target.blur()" min="0" :rules="[numberRule]" />
                                                        <span style="display: none;">{{ row.qty_from_adelphi }}</span>
                                                    </td>
                                                    <td class="spreadsheet-cell text-center">
                                                        <v-text-field :value="calculateTotal(row)" class="disable2-input" type="number" readonly solo hide-details />
                                                        <span style="display: none;">{{ calculateTotal(row) }}</span>
                                                    </td>
                                                    <td class="spreadsheet-cell text-center">
                                                        <v-text-field :value="calculateSisa(row)" class="disable2-input" type="number" readonly solo hide-details />
                                                        <span style="display: none;">{{ calculateSisa(row) }}</span>
                                                    </td>

                                                    <td class="spreadsheet-cell text-center" v-for="(outlet,ido) in outlets" :key="`outlet_${ido}`">
                                                        <v-text-field :value="getQtyPO(outlet.outlet_code, row.product_code)" @input="updateQtyAfterAdjustment(outlet.outlet_code, row.product_code, $event)" class="spreadsheet-input" type="number" solo hide-details />
                                                        <span style="display: none;">{{ getQtyPO(outlet.outlet_code, row.product_code) }}</span>
                                                    </td>

                                                    <td class="spreadsheet-cell text-center" v-for="(outlet,ido) in additionalOutlets" :key="`additional_${ido}`">
                                                        <v-text-field :value="getQtyAdditional(outlet.outlet_code, row.product_code)" @input="updateQtyAdditional(outlet.outlet_code, row.product_code, $event)" class="spreadsheet-input" type="number" solo hide-details />
                                                        <span style="display: none;">{{ getQtyAdditional(outlet.outlet_code, row.product_code) }}</span>
                                                    </td>

                                                    <td class="spreadsheet-cell text-center">
                                                        <v-text-field readonly  class="disable2-input" type="number" solo hide-details @wheel="$event.target.blur()" />
                                                    </td>

                                                    <td class="spreadsheet-cell text-center">
                                                        <v-text-field :value="calculateTotalProductPO(row)" class="disable2-input" type="number" readonly solo hide-details />
                                                        <span style="display: none;">{{ calculateTotalProductPO(row) }}</span>
                                                    </td>
                                                </tr>
                                            </template>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <th class="header-text text-right" colspan="2">Jumlah Total</th>
                                                <th class="spreadsheet-cell text-center">
                                                    <v-text-field :value="totalQtyOrdered" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtyOrdered }}</span>
                                                </th>
                                                <th class="spreadsheet-cell text-center">
                                                    <v-text-field :value="totalQtyLogisticAdjustment" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtyLogisticAdjustment}}</span>
                                                </th>
                                                <th class="spreadsheet-cell text-center" v-if="selectedIsDiambil">
                                                    <v-text-field :value="totalQtyDiambil" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtyDiambil }}</span>
                                                </th>
                                                <th class="spreadsheet-cell text-center" v-if="selectedIsSisa">
                                                    <v-text-field :value="totalQtySisaCoordinator" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtySisaCoordinator }}</span>
                                                </th>

                                                <th class="spreadsheet-cell text-center">
                                                    <v-text-field :value="totalQtyFromOtherCoord" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtyFromOtherCoord }}</span>
                                                </th>
                                                <th class="spreadsheet-cell text-center">
                                                    <v-text-field :value="totalQtyFromAdelphi" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtyFromAdelphi }}</span>
                                                </th>
                                                <th class="spreadsheet-cell text-center">
                                                    <v-text-field :value="totalQtyTotal" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtyTotal }}</span>
                                                </th>
                                                <th class="spreadsheet-cell text-center">
                                                    <v-text-field :value="totalQtySisa" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtySisa }}</span>
                                                </th>

                                                <th class="spreadsheet-cell text-center" v-for="(outlet,ido) in outlets" :key="`outlet_foot_${ido}`">
                                                    <v-text-field :value="getTotalQtyOutlet(outlet)" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ getTotalQtyOutlet(outlet) }}</span>
                                                </th>
                                                <th class="spreadsheet-cell text-center" v-for="(outlet,ido) in additionalOutlets" :key="`additional_foot_${ido}`">
                                                    <v-text-field :value="getTotalAdditionalQtyOutlet(outlet)" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ getTotalAdditionalQtyOutlet(outlet) }}</span>
                                                </th>

                                                <th class="spreadsheet-cell text-center">
                                                    <v-text-field value="" class="disable2-input" type="number" readonly solo hide-details />
                                                </th>

                                                <th class="spreadsheet-cell text-center">
                                                    <v-text-field :value="totalQtyTotalProductPO" class="disable2-input" type="number" readonly solo hide-details />
                                                    <span style="display: none;">{{ totalQtyTotalProductPO }}</span>
                                                </th>
                                            </tr>
                                        </tfoot>
                                    </template>
                                </v-simple-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </div>
                <v-card-actions class="pr-4 mt-3 mx-5">
                    <v-spacer />
                    <v-btn depressed color="primary" @click="saveData" class="px-6">
                        Save
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
        <v-overlay :value="saveProgress" z-index="999">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data() {
        return {
            valid: true,
            date: '',
            dateMenu: false,
            isLoading: false,
            saveProgress: false,
            items: [],
            itemsPrevious: [],
            itemsPreviousSisa: [],
            itemsOther: [],
            coordinators: [],
            masterOutlets: [],
            outlets: [],
            additionalOutlets: [],
            itemsPO: [],
            itemsCP: [],
            additionalOutletItems: [],
            bottles: [],
            selectedVolume: '250',
            selectedCoordinator: '',
            selectedOtherCoordinator: '',
            selectedOtherOutlet: '',
            expiredDate: '',
            reqRule: [v => !!v || 'Harus diisi!'],
            numberRule: val => {
                if (val < 0) return 'Tidak boleh kurang dari 0'
                return true
            },
            selectedCoorName: '',
            selectedPrevCoorName: '',
            selectedNextCoorName: '',
            selectedIsDiambil: false,
            selectedIsSisa: false,
            selectedIsDisableAmbilDari: false,
            orderId: '',
        }
    },

    computed: {
        allOutlets() {
            return [...this.outlets,...this.additionalOutlets];
        },
        totalOutlet() {
            return this.allOutlets.length;
        },
        otherCoordinators() {
            if (this.selectedCoordinator != '') {
                return this.coordinators.filter((coordinator) => !coordinator.code.includes(this.selectedCoordinator));
            } else {
                return this.coordinators;
            }
        },
        selectedCoordinatorName() {
            const coordinator = this.coordinators.find((coor) => coor.code === this.selectedCoordinator);
            if (coordinator) {
                return coordinator.name;
            } else {
                return '';
            }
        },
        selectedOtherCoordinatorName() {
            const coordinator = this.coordinators.find((coor) => coor.code === this.selectedOtherCoordinator);
            if (coordinator) {
                return coordinator.name;
            } else {
                return '';
            }
        },
        filteredOutlets() {
            return this.masterOutlets.filter((outlet) => !this.allOutlets.some((outlet2) => outlet2.outlet_code === outlet.code));
        },
        totalQtyOrdered() {
            return this.items.reduce((total, item) => total + this.calculateQty(item), 0)
        },
        totalQtyLogisticAdjustment() {
            return this.items.reduce((total, item) => total + Number(item.qty_logistic_adjustment), 0)
        },
        totalQtyFromOtherCoord() {
            return this.items.reduce((total, item) => total + Number(item.qty_from_other_coord), 0)
        },
        totalQtyFromAdelphi() {
            return this.items.reduce((total, item) => total + Number(item.qty_from_adelphi), 0)
        },
        totalQtyTotal() {
            return this.items.reduce((total, item) => total + this.calculateTotal(item), 0)
        },
        totalQtySisa() {
            return this.items.reduce((total, item) => total + this.calculateSisa(item), 0)
        },
        totalQtyOutlet1() {
            return this.items.reduce((total, item) => total + Number(item.add_outlet_qty_1), 0)
        },
        totalQtyOutlet2() {
            return this.items.reduce((total, item) => total + Number(item.add_outlet_qty_2), 0)
        },
        totalQtyTotalProductPO() {
            return this.items.reduce((total, item) => total + this.calculateTotalProductPO(item), 0)
        },
        totalQtyDiambil() {
            return this.itemsPrevious.reduce((total, item) => total + this.calculateDiambil(item), 0);
        },
        totalQtySisaCoordinator() {
            return this.itemsPreviousSisa.reduce((total, item) => total + this.calculateSisaCoordinator(item), 0);
        },
        isDisableOutlet1() {
            return this.selectedOtherOutlet1 ? false : true;
        },
        isDisableOutlet2() {
            return this.selectedOtherOutlet2 ? false : true;
        },
        isDisableAmbilDari() {
            // return this.selectedOtherCoordinator ? false : true;
            return this.nextCoordinator ? false : true;
        },
        previousCoordinator() {
            const sortedCoordinators = [...this.coordinators].filter(i => i.sort_no != 0).sort((a, b) => a.sort_no - b.sort_no);
            const currentIndex = sortedCoordinators.findIndex(coor => coor.code === this.selectedCoordinator);

            const previousCoordinator = currentIndex > 0 ? sortedCoordinators[currentIndex - 1] : null;

            return previousCoordinator;
        },
        nextCoordinator() {
            if (this.selectedCoordinator) {
                const sortedCoordinators = [...this.coordinators].filter(i => i.sort_no != 0).sort((a, b) => a.sort_no - b.sort_no);
                const currentIndex = sortedCoordinators.findIndex(coor => coor.code === this.selectedCoordinator);
    
                const nextCoordinator = currentIndex < sortedCoordinators.length - 1 ? sortedCoordinators[currentIndex + 1] : null;
    
                return nextCoordinator;
            } else {
                return null;
            }
        },
        isDiambil() {
            return this.previousCoordinator ? true : false;
        },
        isSisa() {
            return this.previousCoordinator ? true : false;
        }
    },

    async created() {
        this.coordinators = (await this.$store.dispatch('coordinator/getObjs')).data.data;
        this.getBottles();
        this.getMasterOutlets();

        this.date = moment().format('YYYY-MM-DD');

        // this.fetchPembagianKoordinator();
    },

    methods: {
        setDate() {
            this.fetchPembagianKoordinator();
        },
        handleChangeBottle() {
            this.fetchPembagianKoordinator();
        },
        handleCoordinator() {
            this.fetchPembagianKoordinator();
        },
        handleOtherCoordinator() {
            this.fetchPembagianKoordinator();
            this.items = this.items.map(item => ({
                ...item,
                qty_from_other_coord: this.calculateQtyFromOtherCoordinator(item),
            }));
        },
        handleOutlet(value) {
            const existsOutlet = this.additionalOutlets.some((outlet) => outlet.outlet_code === value.code);
            if (!existsOutlet) {
                this.additionalOutlets.push({outlet_code: value.code, outlet_name: value.name, is_additional: 1});

                const existsItemAdditional = this.additionalOutletItems.filter((row) => row.coordinator_code === this.selectedCoordinator
                    && row.outlet_code === value.code);

                if (existsItemAdditional.length == 0) {

                    if (this.additionalOutletItems.length > 0) {
                        this.items.forEach((item) => {
                            const found = this.additionalOutletItems.some((additionalItem) => additionalItem.variant_code == item.product_code 
                                && additionalItem.outlet_code == value.code && additionalItem.coordinator_code == this.selectedCoordinator);
                            if (!found) {
                                this.additionalOutletItems.push({
                                    order_id: item.order_id,
                                    variant_code: item.product_code,
                                    variant_name: item.product_name,
                                    variant_size: item.product_size,
                                    coordinator_code: this.selectedCoordinator,
                                    outlet_code: value.code,
                                    qty: 0
                                });
                            }
                        });
                    } else {
                        this.additionalOutletItems = this.items.map((item) => ({
                            order_id: item.order_id,
                            variant_code: item.product_code,
                            variant_name: item.product_name,
                            variant_size: item.product_size,
                            coordinator_code: this.selectedCoordinator,
                            outlet_code: value.code,
                            qty: 0
                        }));
                    }
                    

                }
            }
        },
        removeAdditionalOutlet(outletCode) {
            console.log(outletCode);
            this.additionalOutlets = this.additionalOutlets.filter(outlet => outlet.outlet_code !== outletCode);
            this.selectedOtherOutlet = null;
            console.log(this.additionalOutletItems);

            this.additionalOutletItems = this.additionalOutletItems.filter((row) => row.outlet_code !== outletCode);

            console.log(this.additionalOutletItems);
        },
        getBottles() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.bottles = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        async getMasterOutlets() {
            let response = await this.$store.dispatch('outlet/getObjs');
            if (response.data.status == 'success') {
                this.masterOutlets = response.data.data;
            }
        },
        calculateQty(item) {
            let result = 0;
            const data = this.itemsCP.find((row) => row.product_code === item.product_code);
            if (data) {
                result = parseInt(data.quantity_awal);
            }

            return result;
        },
        calculateQtyLogisticAdjustment(item) {
            let result = 0;
            const data = this.itemsCP.find((row) => row.product_code === item.product_code);
            if (data) {
                result = parseInt(data.qty_logistic_adjustment);
            }

            return result;
        },
        calculateQtyFromOtherCoordinator(item) {
            let result = 0;

            if (this.itemsOther.length > 0) {
                const product = this.itemsOther.find((row) => row.product_code == item.product_code);
                if (product) {
                    result = product.qty_from_other_coord;
                }
            }

            return result;
        },
        calculateQtyOutlet1(item) {
            return this.selectedOtherOutlet1 ? item.add_outlet_qty_1 : 0;
        },
        calculateQtyOutlet2(item) {
            return this.selectedOtherOutlet2 ? item.add_outlet_qty_2 : 0;
        },
        calculateTotal(item) {
            const result = this.calculateQty(item) + this.calculateDiambil(item) + this.calculateSisaCoordinator(item) + parseInt(item.qty_from_other_coord) + parseInt(item.qty_from_adelphi) +  + parseInt(item.qty_logistic_adjustment);
            return result;
        },
        calculateSisa(item) {
            const result = this.calculateTotal(item) - this.calculateTotalProductPO(item);

            this.$set(item, 'qty_sisa', result);

            return result;
        },
        calculateDiambil(row) {
            let result = 0;

            if (this.itemsPrevious.length > 0) {
                const product = this.itemsPrevious.find(p => p.product_code == row.product_code);
                if (product) {
                    result = product.qty_from_other_coord;
                    if (result > 0) {
                        result = -Math.abs(result);
                    }
                }
            }
            return result;
        },
        calculateSisaCoordinator(row) {
            let result = 0;

            if (this.itemsPreviousSisa.length > 0) {
                const product = this.itemsPreviousSisa.find(p => p.product_code == row.product_code);
                if (product) {
                    result = product.qty_sisa;
                }
            }
            return result;
        },
        calculateTotalProductPO(item) {
            let result = 0;
            const productCode = item.product_code;

            let totalPO = this.itemsPO.filter(product => product.product_code == productCode)
                .reduce((sum, product) => sum + parseInt(product.quantity_ordered), 0);

            let totalAdditional = this.additionalOutletItems.filter(product => product.variant_code == productCode)
                .reduce((sum, product) => sum + parseInt(product.qty), 0);

            result += totalPO + totalAdditional;

            result += parseInt(item.add_outlet_qty_1) + parseInt(item.add_outlet_qty_2);
            return result;
        },
        getQtyAdditional(outletCode, productCode) {
            let result = 0;

            const item = this.additionalOutletItems.find((row) => row.outlet_code === outletCode && row.variant_code === productCode);
            if (item) {
                result = parseInt(item.qty);
            }

            return result;
        },
        updateQtyAdditional(outletCode, productCode, value) {
            const item = this.additionalOutletItems.find((row) => row.outlet_code === outletCode && row.variant_code === productCode);
            if (item) {
                item.qty = value;
            }
        },
        getQtyPO(outletCode, productCode) {
            let result = 0;

            const item = this.itemsPO.find((row) => row.outlet_code === outletCode && row.product_code === productCode);
            if (item) {
                result = parseInt(item.quantity_ordered);
            }

            return result;
        },
        updateQtyAfterAdjustment(outletCode, productCode, value) {
            const itemPO = this.itemsPO.find((row) => row.outlet_code == outletCode && row.product_code === productCode);
            if (itemPO) {
                itemPO.quantity_ordered = value;
            }
        },
        getTotalQtyOutlet(outlet) {
            return this.itemsPO.filter((row) => row.outlet_code === outlet.outlet_code)
                .reduce((total, item) => total + Number(item.quantity_ordered), 0);
        },
        getTotalAdditionalQtyOutlet(outlet) {
            return this.additionalOutletItems.filter((row) => row.outlet_code === outlet.outlet_code)
                .reduce((total, item) => total + Number(item.qty), 0);
        },
        async getDataProducts() {
            let response = await this.$store.dispatch('variant/getObjs')
            if (response.data.status == 'success') {
                this.products = response.data.data;
            }
        },
        refreshData() {
            this.fetchPembagianKoordinator();
        },
        async fetchPembagianKoordinator() {
            this.isLoading = true;
            this.selectedOtherOutlet = null;

            try {
                const data = (await this.$store.dispatch('pembagiankoordinator/getData', {
                    date: this.date,
                    coordinator: this.selectedCoordinator === null ? '' : this.selectedCoordinator,
                    previous_coordinator: this.previousCoordinator === null ? '' : this.previousCoordinator.code,
                    next_coordinator: this.nextCoordinator === null ? '' : this.nextCoordinator.code,
                    // other_coordinator: this.selectedOtherCoordinator === null ? '' : this.selectedOtherCoordinator,
                    size: this.selectedVolume,
                }));

                this.expiredDate = data.expired_date;

                if (data.outlets.length > 0) {
                    this.outlets = data.outlets.map((outlet) => ({
                        ...outlet,
                        is_additional: 0
                    }));
                }

                this.items = data.items;
                this.itemsPO = data.items_po;
                this.itemsCP = data.items_cp;
                this.itemsPrevious = data.items_previous;
                this.itemsPreviousSisa = data.items_previous_sisa;
                this.itemsOther = data.items_next;
                this.orderId = data.order_id;

                this.additionalOutlets = data.additional_outlets;
                this.additionalOutletItems = data.additional_outlet_items;

                // 
                this.additionalOutlets.forEach((outlet) => {
                    this.items.forEach((item) => {
                        const found = this.additionalOutletItems.some((additionalItem) => additionalItem.variant_code == item.product_code 
                            && additionalItem.outlet_code == outlet.outlet_code && additionalItem.coordinator_code == this.selectedCoordinator);
                        if (!found) {
                            this.additionalOutletItems.push({
                                date: this.date,
                                order_id: item.order_id,
                                variant_code: item.product_code,
                                variant_name: item.product_name,
                                variant_size: item.product_size,
                                coordinator_code: this.selectedCoordinator,
                                outlet_code: outlet.outlet_code,
                                qty: 0
                            });
                        }
                    });
                });


                //
                this.selectedCoorName = this.selectedCoordinatorName ? this.selectedCoordinatorName : '...';
                this.selectedPrevCoorName = this.previousCoordinator ? this.previousCoordinator.name : '...';
                this.selectedNextCoorName = this.nextCoordinator ? this.nextCoordinator.name : '...';
                this.selectedIsDiambil = this.isDiambil;
                this.selectedIsSisa = this.isSisa;
                this.selectedIsDisableAmbilDari = this.isDisableAmbilDari;
            } catch (error) {
                console.log('Error fetching pembagian koordinator:', error);
            } finally {
                this.isLoading = false;
            }
        },
        async saveData() {
            await this.$refs.pembagianKoordinatorForm.validate();

            if (!this.valid) return;

            this.saveProgress = true;

            const saveItems = this.items.map((item) => {
                return {
                    'order_id': item.order_id ? item.order_id : this.orderId,
                    'product_code': item.product_code,
                    'qty_from_adelphi': item.qty_from_adelphi,
                    'qty_from_other_coord': item.qty_from_other_coord,
                    'qty_logistic_adjustment': item.qty_logistic_adjustment,
                    'add_outlet_code_1': this.selectedOtherOutlet1,
                    'add_outlet_code_2': this.selectedOtherOutlet2,
                    'add_outlet_qty_1': item.add_outlet_qty_1,
                    'add_outlet_qty_2': item.add_outlet_qty_2,
                    'qty_sisa': item.qty_sisa,
                };
            });

            const saveItemsPO = this.itemsPO.map((item) => {
                return {
                    'po_code': item.po_code,
                    'outlet_code': item.outlet_code,
                    'product_code': item.product_code,
                    'quantity_after_adjustment': item.quantity_ordered,
                }
            });

            const payload = {
                delivery_date: this.date,
                coordinator_code: this.selectedCoordinator,
                items: saveItems,
                items_po: saveItemsPO,
                additional_items: this.additionalOutletItems,
                variant_size: this.selectedVolume,
            };

            // Only add from_other_coord_code if nextCoordinator exists
            if (this.nextCoordinator?.code) {
                payload.from_other_coord_code = this.nextCoordinator.code;
            }
            const result = await this.$store.dispatch('pembagiankoordinator/store', payload);

            if (result.status == 200 || result.status == 201) {
                this.saved = true
                this.$store.commit('setSnackbar', {saveSuccess: true, successMessage: 'Data berhasil diupdate'})
                this.fetchPembagianKoordinator();
            } else {
                this.saveError = true
            }

            this.saveProgress = false
        },
        export2xls() {
            const wb = utils.table_to_book(this.$refs.tableKoordinator.$el.firstChild.firstChild);
            writeFileXLSX(wb, "Pembagian-Koordinator.xlsx");
        }
    }
}
</script>

<style scoped>
.spreadsheet-table {
  border-collapse: collapse;
  width: 100%;
}

.header-cell,
.spreadsheet-cell {
  border: 1px solid #ddd;
  padding: 8px !important;
  text-align: left;
  min-width: 100px;
}

.spreadsheet-cell {
  background-color: #f9f9f9;
  cursor: pointer;
  padding: 0px !important;
}

.spreadsheet-cell:focus-within {
  background-color: #e6f7ff;
  outline: none;
}

.spreadsheet-input {
  padding: 0 !important;
  margin: 0;
  border: none;
  box-shadow: none;
  /* background-color: transparent !important; */
  background-color: yellow !important;
  font-size: inherit;
  width: 100%;
}

.spreadsheet-input input {
  padding: 0 !important;
  border: none;
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__slot {
  background-color: #ffe169 !important;
}

.spreadsheet-input ::v-deep .v-input__control input {
  background-color: #ffe169 !important;
  text-align: center;
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}

.small-select {
  height: 40px; /* Adjust the height of the component */
}
.small-select .v-input__control {
  min-height: 40px;
  line-height: 40px;
}
</style>